import React, { useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Form } from "antd";

import MedicationForm from "../MedicationForm/MedicationForm";
import { OutlinedButton, PrimaryButton } from "../../../customComponent/Button";
import { PopupStyledModal } from "../../../customComponentNewDesign/CustomPopupModal";

const Popup = styled(PopupStyledModal)`
  .ant-modal-title {
    margin-bottom: 20px;
  }
`;

const AddMedicationModal = ({ addNewMedication, showPopupRef }) => {
  const { t } = useTranslation();
  const [popupShown, setPopupShown] = useState(false);
  const [form] = Form.useForm();

  const showPopup = useCallback(() => setPopupShown(true), []);

  const handleSubmitEvent = useCallback(
    ({ rxnormDrug, medicationData }) => {
      addNewMedication({ rxnormDrug, medicationData });
      setPopupShown(false);
    },
    [addNewMedication]
  );

  const handleCancel = useCallback(() => setPopupShown(false), []);

  useEffect(() => {
    showPopupRef.current = showPopup;
  }, [showPopupRef, showPopup]);

  return (
    <Popup
      destroyOnClose={true}
      open={popupShown}
      onCancel={handleCancel}
      title={t("managePatientDetails.medications_section.medication_modal.add_new_medication")}
      footer={[
        <OutlinedButton key="cancelButton" onClick={handleCancel}>
          {t("managePatientDetails.medications_section.medication_modal.cancel")}
        </OutlinedButton>,
        <PrimaryButton form="medication_editor" key="submit" htmlType="submit">
          {t("managePatientDetails.medications_section.medication_modal.add_medication")}
        </PrimaryButton>
      ]}
    >
      <MedicationForm handleSubmitEvent={handleSubmitEvent} form={form} />
    </Popup>
  );
};

export default AddMedicationModal;
